import { h, Fragment } from "preact";
import {
  PageHeader,
  Switch,
  Badge,
  Avatar,
  Typography,
  SunOutlined,
  MoonOutlined,
} from "antd";
import { BellOutlined, UserOutlined } from "@ant-design/icons";
import { getPageParams } from "./HeaderUtils";
import { useContext, useEffect, useState } from "preact/hooks";
import { KeycloakContext } from "../../providers/KeycloakContext";
import useProfile from '../../pages/Account/useProfile'

export default function Header() {
  const { title, onBack } = getPageParams();
  const { keycloakClient } = useContext(KeycloakContext);
  const {options, profile, teammates} = useProfile();
  const [fullName, setFullName] = useState(<br/>); 

  useEffect(()=>{
    setFullName(profile?.contact_person_full_name || "John Doe");
  }, [profile]);

  let userRole = "verigram-admin";

  const nameStyle = {
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px" /* 160% */,
    letterSpacing: "-0.3px",
    color: "#0F0C2B",
    marginBottom: "-6px",
  };
  const roleStyle = {
    color: "#B6BFDA",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px" /* 240% */,
    letterSpacing: "-0.2px",
    marginBottom: "0px",
  };
  return (
    <>
      <PageHeader
        title={title}
        onBack={onBack}
        extra={[
          <div
            style={{ display: "flex", columnGap: "32px", alignItems: "center" }}
          >
            {/* <Switch
              checkedChildren={"🌝"}
              unCheckedChildren={"🌙"}
              onChange={(checked) => {}}
              style={{ backgroundColor: "#B6BFDA" }}
            />
            <Badge
              count={1}
              style={{ marginLeft: "16px", backgroundColor: "#3C8DFC" }}
            >
              <BellOutlined
                style={{
                  fontSize: "24px",
                  color: "#0F0C2B",
                  cursor: "pointer",
                }}
              />
            </Badge> */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Avatar
                icon={<UserOutlined />}
                style={{ marginRight: "8px", backgroundColor: "#B6BFDA" }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "6px",
                }}
              >
                <h4 id="user-name" style={nameStyle}>{fullName}</h4>
                <p id="user-role" style={roleStyle}>{userRole}</p>
              </div>
            </div>
          </div>,
        ]}
      />
    </>
  );
}
